<template>
  <div class="skeleton">
    <div class="skeleton-anime">
      <h1 class="opacity-0">
        header skeleton
      </h1>
    </div>
  </div>
</template>
